

export class TzInfo{

  id: string;
  name: string;
  diff: number;

}
